__turbopack_context__.v({
  "editView": "DetailsSection-module-scss-module__pz5CIq__editView",
  "missingData": "DetailsSection-module-scss-module__pz5CIq__missingData",
  "missingDataAlert": "DetailsSection-module-scss-module__pz5CIq__missingDataAlert",
  "root": "DetailsSection-module-scss-module__pz5CIq__root",
});
